// Site settings - Languages and Currencies matching mobile app

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: 'https://flagcdn.com/w40/us.png' },
  { code: 'pl', label: 'Polish', flag: 'https://flagcdn.com/w40/pl.png' },
  { code: 'ar', label: 'Arabic', flag: 'https://flagcdn.com/w40/sa.png' },
  { code: 'es', label: 'Spanish', flag: 'https://flagcdn.com/w40/es.png' },
  { code: 'it', label: 'Italian', flag: 'https://flagcdn.com/w40/it.png' },
  { code: 'de', label: 'German', flag: 'https://flagcdn.com/w40/de.png' },
  { code: 'hu', label: 'Hungarian', flag: 'https://flagcdn.com/w40/hu.png' },
  { code: 'tr', label: 'Turkish', flag: 'https://flagcdn.com/w40/tr.png' },
  { code: 'cs', label: 'Czech', flag: 'https://flagcdn.com/w40/cz.png' },
  { code: 'fr', label: 'French', flag: 'https://flagcdn.com/w40/fr.png' },
  { code: 'nl', label: 'Dutch', flag: 'https://flagcdn.com/w40/nl.png' },
  { code: 'zh', label: 'Chinese', flag: 'https://flagcdn.com/w40/cn.png' },
  { code: 'lv', label: 'Latvian', flag: 'https://flagcdn.com/w40/lv.png' },
  { code: 'uk', label: 'Ukrainian', flag: 'https://flagcdn.com/w40/ua.png' },
  { code: 'ca', label: 'Catalan', flag: 'https://flagcdn.com/w40/ad.png' },
  { code: 'sl', label: 'Slovenian', flag: 'https://flagcdn.com/w40/si.png' },
  { code: 'fi', label: 'Finnish', flag: 'https://flagcdn.com/w40/fi.png' },
  { code: 'da', label: 'Danish', flag: 'https://flagcdn.com/w40/dk.png' },
  { code: 'ja', label: 'Japanese', flag: 'https://flagcdn.com/w40/jp.png' },
  { code: 'hr', label: 'Croatian', flag: 'https://flagcdn.com/w40/hr.png' },
  { code: 'nb', label: 'Norwegian', flag: 'https://flagcdn.com/w40/no.png' },
  { code: 'lt', label: 'Lithuanian', flag: 'https://flagcdn.com/w40/lt.png' },
  { code: 'sk', label: 'Slovak', flag: 'https://flagcdn.com/w40/sk.png' },
  { code: 'sv', label: 'Swedish', flag: 'https://flagcdn.com/w40/se.png' },
  { code: 'bg', label: 'Bulgarian', flag: 'https://flagcdn.com/w40/bg.png' },
  { code: 'ru', label: 'Russian', flag: 'https://flagcdn.com/w40/ru.png' },
  { code: 'el', label: 'Greek', flag: 'https://flagcdn.com/w40/gr.png' },
  { code: 'pt', label: 'Portuguese', flag: 'https://flagcdn.com/w40/pt.png' },
  { code: 'ro', label: 'Romanian', flag: 'https://flagcdn.com/w40/ro.png' },
  { code: 'et', label: 'Estonian', flag: 'https://flagcdn.com/w40/ee.png' },
]

export const CURRENCIES = [
  { code: 'USD', label: 'US Dollar' },
  { code: 'EUR', label: 'Euro' },
  { code: 'GBP', label: 'British Pound' },
  { code: 'CAD', label: 'Canadian Dollar' },
  { code: 'AUD', label: 'Australian Dollar' },
  { code: 'JPY', label: 'Japanese Yen' },
  { code: 'CHF', label: 'Swiss Franc' },
  { code: 'CNY', label: 'Chinese Yuan' },
  { code: 'INR', label: 'Indian Rupee' },
  { code: 'MXN', label: 'Mexican Peso' },
  { code: 'BRL', label: 'Brazilian Real' },
  { code: 'KRW', label: 'South Korean Won' },
  { code: 'SGD', label: 'Singapore Dollar' },
  { code: 'THB', label: 'Thai Baht' },
  { code: 'IDR', label: 'Indonesian Rupiah' },
  { code: 'MYR', label: 'Malaysian Ringgit' },
  { code: 'PHP', label: 'Philippine Peso' },
  { code: 'NZD', label: 'New Zealand Dollar' },
  { code: 'SEK', label: 'Swedish Krona' },
  { code: 'NOK', label: 'Norwegian Krone' },
  { code: 'DKK', label: 'Danish Krone' },
  { code: 'ZAR', label: 'South African Rand' },
  { code: 'AED', label: 'UAE Dirham' },
  { code: 'SAR', label: 'Saudi Riyal' },
  { code: 'TWD', label: 'Taiwan Dollar' },
  { code: 'HKD', label: 'Hong Kong Dollar' },
  { code: 'TRY', label: 'Turkish Lira' },
  { code: 'PLN', label: 'Polish Zloty' },
  { code: 'CZK', label: 'Czech Koruna' },
  { code: 'ILS', label: 'Israeli Shekel' },
  { code: 'CLP', label: 'Chilean Peso' },
  { code: 'COP', label: 'Colombian Peso' },
  { code: 'ARS', label: 'Argentine Peso' },
  { code: 'PEN', label: 'Peruvian Sol' },
  { code: 'VND', label: 'Vietnamese Dong' },
  { code: 'EGP', label: 'Egyptian Pound' },
  { code: 'QAR', label: 'Qatari Riyal' },
  { code: 'KWD', label: 'Kuwaiti Dinar' },
  { code: 'BHD', label: 'Bahraini Dinar' },
  { code: 'OMR', label: 'Omani Rial' },
]

// Local storage keys
const LANGUAGE_KEY = 'voyabay_language'
const CURRENCY_KEY = 'voyabay_currency'
const CURRENCY_USER_CHOSEN_KEY = 'voyabay_currency_user_chosen'

// Cloudflare Worker geo endpoint — returns { country: "TH" } using request.cf.country
const WORKER_GEO_URL = 'https://voyabayliteapi.dylan-mclean.workers.dev/api/geo'

export const ASIA_COUNTRY_CODES = new Set([
  'AE', 'AF', 'AM', 'AZ', 'BD', 'BH', 'BN', 'BT', 'CC', 'CN', 'CX', 'GE',
  'HK', 'ID', 'IL', 'IN', 'IO', 'IQ', 'IR', 'JO', 'JP', 'KG', 'KH', 'KP',
  'KR', 'KW', 'KZ', 'LA', 'LB', 'LK', 'MM', 'MN', 'MO', 'MV', 'MY', 'NP',
  'OM', 'PH', 'PK', 'PS', 'QA', 'SA', 'SG', 'SY', 'TH', 'TJ', 'TL', 'TM',
  'TR', 'TW', 'UZ', 'VN', 'YE',
])

// ISO country code → currency code. Only covers currencies supported in CURRENCIES above.
const COUNTRY_TO_CURRENCY = {
  US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', JP: 'JPY', CH: 'CHF', CN: 'CNY',
  IN: 'INR', MX: 'MXN', BR: 'BRL', KR: 'KRW', SG: 'SGD', TH: 'THB', ID: 'IDR',
  MY: 'MYR', PH: 'PHP', NZ: 'NZD', SE: 'SEK', NO: 'NOK', DK: 'DKK', ZA: 'ZAR',
  AE: 'AED', SA: 'SAR', TW: 'TWD', HK: 'HKD', TR: 'TRY', PL: 'PLN', CZ: 'CZK',
  IL: 'ILS', CL: 'CLP', CO: 'COP', AR: 'ARS', PE: 'PEN', VN: 'VND', EG: 'EGP',
  QA: 'QAR', KW: 'KWD', BH: 'BHD', OM: 'OMR',
  // Eurozone
  DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR',
  PT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', SK: 'EUR', SI: 'EUR', LV: 'EUR',
  LT: 'EUR', EE: 'EUR', CY: 'EUR', MT: 'EUR', LU: 'EUR', HR: 'EUR',
}

function detectCurrencyFromLocale() {
  try {
    const lang = (typeof navigator !== 'undefined' && navigator.language) || ''
    // Parse region from tags like "th-TH", "en-GB", "zh-Hant-HK"
    const match = lang.match(/[-_]([A-Z]{2})\b/i)
    const region = match ? match[1].toUpperCase() : ''
    return COUNTRY_TO_CURRENCY[region] || null
  } catch {
    return null
  }
}

export function getSiteSettings() {
  const language = localStorage.getItem(LANGUAGE_KEY) || 'en'
  let currency = localStorage.getItem(CURRENCY_KEY)
  if (!currency) {
    currency = detectCurrencyFromLocale() || 'USD'
    try { localStorage.setItem(CURRENCY_KEY, currency) } catch {}
  }
  return { language, currency }
}

// Kept for backward compatibility — auto-detection now happens inside getSiteSettings()
export function initCurrencyDetection() {}

export function setSiteSettings(language) {
  if (language) localStorage.setItem(LANGUAGE_KEY, language.toLowerCase())
}

export function setSiteCurrency(currency, opts = {}) {
  if (!currency) return
  localStorage.setItem(CURRENCY_KEY, currency.toUpperCase())
  if (opts.userChosen) {
    try { localStorage.setItem(CURRENCY_USER_CHOSEN_KEY, '1') } catch {}
  }
}

export function hasUserChosenCurrency() {
  try { return localStorage.getItem(CURRENCY_USER_CHOSEN_KEY) === '1' } catch { return false }
}

export async function detectCountryFromIp() {
  try {
    const res = await fetch(WORKER_GEO_URL, { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    const country = String(data?.country || '').toUpperCase()
    return /^[A-Z]{2}$/.test(country) ? country : null
  } catch {
    return null
  }
}

export function isAsianCountry(countryCode) {
  return ASIA_COUNTRY_CODES.has(String(countryCode || '').toUpperCase())
}

// IP-based currency detection — calls the Cloudflare Worker, which reads
// `request.cf.country` from the edge. Returns the mapped currency or null on
// failure (VPN users land in whatever country their exit node is in).
export async function detectCurrencyFromIp() {
  const country = await detectCountryFromIp()
  return COUNTRY_TO_CURRENCY[country] || null
}

export function getLanguageByCode(code) {
  return LANGUAGES.find(l => l.code.toLowerCase() === code?.toLowerCase()) || LANGUAGES[0]
}

export function getCurrencyByCode(code) {
  return CURRENCIES.find(c => c.code.toUpperCase() === code?.toUpperCase()) || CURRENCIES[0]
}

// Collect the full currency prefix (e.g. "CA$" for CAD) from Intl parts.
// Modern browsers split CAD into [{currency:'CA'},{literal:'$'},...] — we need
// to concatenate both parts until we hit the first digit.
function extractSymbolFromParts(parts) {
  let symbol = ''
  for (const p of parts) {
    if (p.type === 'integer' || p.type === 'decimal' || p.type === 'fraction') break
    symbol += p.value
  }
  return symbol.trim()
}

// USD's Intl symbol is bare "$", indistinguishable from AUD's "A$" to external
// parsers (e.g. Google Hotel Center). Normalise it to "US$" to match the
// pattern used by every other dollar currency (CA$, A$, NZ$, HK$, S$…).
function normaliseSymbol(symbol, currencyCode) {
  if ((currencyCode || '').toUpperCase() === 'USD' && symbol === '$') return 'US$'
  return symbol
}

// Get currency symbol using Intl.NumberFormat (built-in, accurate for all currencies)
export function getCurrencySymbol(currencyCode) {
  try {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    const symbol = extractSymbolFromParts(formatter.formatToParts(0)) || currencyCode
    return normaliseSymbol(symbol, currencyCode)
  } catch (e) {
    return currencyCode || '$'
  }
}

// Format price with proper currency formatting (includes space between symbol and number)
export function formatPrice(amount, currencyCode) {
  try {
    const rounded = Math.round(amount)
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    const parts = formatter.formatToParts(rounded)
    const symbol = normaliseSymbol(extractSymbolFromParts(parts), currencyCode)
    const number = parts.filter(p => p.type === 'integer' || p.type === 'group' || p.type === 'decimal' || p.type === 'fraction').map(p => p.value).join('')
    return `${symbol} ${number}`
  } catch (e) {
    return `${getCurrencySymbol(currencyCode)} ${Math.round(amount).toLocaleString()}`
  }
}

// Format price compactly — uses dots as thousand separators for large-number currencies (IDR, VND, KRW, etc.)
export function formatPriceCompact(amount, currencyCode) {
  try {
    const rounded = Math.round(amount)
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    const parts = formatter.formatToParts(rounded)
    const symbol = normaliseSymbol(extractSymbolFromParts(parts), currencyCode)
    const number = parts.filter(p => p.type === 'integer' || p.type === 'group' || p.type === 'decimal' || p.type === 'fraction').map(p => p.value).join('')

    // For large numbers (100K+), swap commas for dots (Expedia/Booking style)
    if (rounded >= 100_000) {
      return `${symbol}${number.replace(/,/g, '.')}`
    }

    return `${symbol} ${number}`
  } catch (e) {
    return formatPrice(amount, currencyCode)
  }
}

// Format price with decimals (for checkout totals)
export function formatPriceWithDecimals(amount, currencyCode) {
  try {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    const parts = formatter.formatToParts(amount)
    const symbol = normaliseSymbol(extractSymbolFromParts(parts), currencyCode)
    const number = parts.filter(p => p.type === 'integer' || p.type === 'group' || p.type === 'decimal' || p.type === 'fraction').map(p => p.value).join('')
    return `${symbol} ${number}`
  } catch (e) {
    return `${getCurrencySymbol(currencyCode)} ${amount.toFixed(2)}`
  }
}
